import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "OperationTypeDashboardPage" */
	'pages/intervention/OperationType/OperationTypeDashboardPage'));

export default [{ component, exact: true, path: '/operation_types/:operationTypeId' }];